<h2 mat-dialog-title>Expire project</h2>

<mat-dialog-content>
    <p>The project has been had to the yesterday's report. That report can be downloaded using the following URL (<a href="https://doc.mediaclip.ca/hub/api/projects/expiring-projects/" target="_blank">documentation</a>):</p>
    <p><code adminCopyToClipboard>{{ data.url }}</code></p>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Ok</button>
</mat-dialog-actions>
